import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";

@Options({
    template: false,
    ui: {
        dropdownTrigger: "[data-js-ui=dropdown-trigger]",
        dropdownContent: "[data-js-ui=dropdown-content]",
        dropdownClose:   "[data-js-ui=dropdown-close]",
    }
})
export default class DropdownView extends Marionette.View<Backbone.Model>{

    _activeClass = "is-active";

    onClick(event) {
        if (!$.contains(this.el, event.target)) {
            this.hideDropdownContent();
        }
    }

    onKeydown(event) {
        if (event.keyCode == 27) {
            this.hideDropdownContent();
        }
    }

    listenForClick() {
        $(window).on("click", _.bind(this.onClick, this));
    }

    listenForKeydown() {
        $(window).on("keydown", _.bind(this.onKeydown, this));
    }

    unlistenForClick() {
        $(window).off("click");
    }

    unlistenForKeydown() {
        $(window).off("keydown");
    }

    onBeforeDetach() {
        this.unlistenForClick();
        this.unlistenForKeydown();
    }

    @on("click @ui.dropdownTrigger")
    onDropdownTriggerClick() {
        console.log("onDropdownTriggerClick");
        if (this.$el.hasClass(this._activeClass)) {
            this.hideDropdownContent();
        } else {
            this.showDropdownContent();
        }
    }

    @on("click @ui.dropdownClose")
    onDropdownCloseClick() {
        this.hideDropdownContent();
    }

    showDropdownContent() {
        this.$el.addClass(this._activeClass);
        _.delay(_.bind(this.listenForClick, this), 300);
        _.delay(_.bind(this.listenForKeydown, this), 300);

        var elementPosition = this.$el.get(0).offsetTop;

        // Disable smooth scroll desktop sizes
        if ($(window).width() < 1000) {
            $("html, body").animate({ scrollTop: (elementPosition - 120) }, 500);
        }
    }

    hideDropdownContent() {
        this.$el.removeClass(this._activeClass);
        this.unlistenForClick();
        this.unlistenForKeydown();
    }
}



// WEBPACK FOOTER //
// ./@modules/views/dropdown-view.ts